/* The learner's vocal range; vocal exercises are placed inside its comfortable middle (tessitura). */
import type { Voice } from '../../core/audio';
import { getSettings } from '../../core/store';
import { noteName } from '../../core/theory';

export interface VoiceType {
  id: string;
  name: string;
  /** MIDI */
  lo: number;
  hi: number;
}

export const VOICE_TYPES: readonly VoiceType[] = [
  { id: 'bas', name: 'Bas', lo: 40, hi: 64 },
  { id: 'bariton', name: 'Bariton', lo: 45, hi: 69 },
  { id: 'tenor', name: 'Tenor', lo: 48, hi: 72 },
  { id: 'alto', name: 'Alto', lo: 53, hi: 77 },
  { id: 'mezzo', name: 'Mezzo-soprano', lo: 57, hi: 81 },
  { id: 'soprano', name: 'Soprano', lo: 60, hi: 84 },
];

/** Vocal exercises play their guide notes on piano (or sine) rather than guitar. */
export const vinst = (): Voice => (getSettings().instrument === 'sine' ? 'sine' : 'piano');

export function range(): { lo: number; hi: number } | null {
  const s = getSettings();
  if (s.voiceLow != null && s.voiceHigh != null) return { lo: s.voiceLow, hi: s.voiceHigh };
  const vt = VOICE_TYPES.find((v) => v.id === s.voiceType);
  return vt ? { lo: vt.lo, hi: vt.hi } : null;
}

/** Comfortable singing area: a few semitones inside the range, at least a fifth wide. */
export function tess(): { lo: number; hi: number } {
  const r = range() || { lo: 48, hi: 67 };
  const lo = r.lo + 3;
  const hi = Math.max(r.hi - 4, lo + 7);
  return { lo, hi };
}

export function rangeText(): string {
  const r = range();
  return r ? `${noteName(r.lo)} – ${noteName(r.hi)}` : 'belirlenmedi';
}
